import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-689 (4.4 home-address).
export const HomeAddressScreen = () => (
  <StubScreen id="home-address" heading="Ihre Meldeadresse" />
);
